"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Cookies = __importStar(require("js-cookie"));
var CookiesStorage = /** @class */ (function () {
    function CookiesStorage() {
    }
    CookiesStorage.prototype.setItem = function (key, data) {
        Cookies.set(key, data);
    };
    CookiesStorage.prototype.getItem = function (key) {
        return Cookies.getJSON(key);
    };
    CookiesStorage.prototype.removeItem = function (key) {
        Cookies.remove(key);
    };
    return CookiesStorage;
}());
exports.default = CookiesStorage;
//# sourceMappingURL=CookiesStorage.js.map